const shopUrl = window.__GGShopUrl || '';

export function Login(
    loginData: {
        email: string;
        password: string;
    },
    onSuccess: () => void,
    onWrongCredentials: () => void,
    onError?: (errorMessage: string) => void,
    onFailure?: (errorMessage: string) => void,
) {
    fetch(`${shopUrl}/ggfrontendlogin`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(loginData),
        credentials: 'include',
    })
        .then(
            (response): Promise<[number, { success: boolean; sErrorMessages: string }]> =>
                response.json().then((json) => [response.status, json]),
        )
        .then(([status, json]) => {
            if (status === 401) {
                return onWrongCredentials();
            }

            if (json.success === true) {
                onSuccess();
            } else if (json.sErrorMessages) {
                if (onError && typeof onError === 'function') {
                    onError(json.sErrorMessages);
                }
            } else {
                if (onError && typeof onError === 'function') {
                    onError('unexpected error');
                }
            }
        })
        .catch((error) => {
            if (onFailure && typeof onFailure === 'function') {
                onFailure('Der Login konnte aufgrund eines allgemeinen Fehlers nicht durchgeführt werden.');
            }
        });
}
